import { IconButton, InputBase, Menu, MenuItem, Toolbar } from "@mui/material";
import { useState } from "react";
import {
  MoreHoriz as MoreHorizIcon,
  CloudUpload as CloudUploadIcon,
} from "@mui/icons-material";
import { useTransferQueue } from "./app/transferQueue";

function Header({
  search,
  onSearchChange,
  setShowProgressDialog,
}: {
  search: string;
  onSearchChange: (newSearch: string) => void;
  setShowProgressDialog: (show: boolean) => void;
}) {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const transferQueue = useTransferQueue();

  // 有上传/下载任务进行中时显示动画图标
  const hasActive = transferQueue.some(
    (task) =>
      task.status === "pending" || task.status === "in-progress"
  );
  const activeCount = transferQueue.filter(
    (t) => t.status === "pending" || t.status === "in-progress"
  ).length;

  return (
    <Toolbar disableGutters sx={{ padding: 1 }}>
      <InputBase
        size="small"
        fullWidth
        placeholder="Search…"
        value={search}
        onChange={(e) => onSearchChange(e.target.value)}
        sx={{
          backgroundColor: "whitesmoke",
          borderRadius: "999px",
          padding: "8px 16px",
        }}
      />
      {hasActive && (
        <IconButton
          aria-label="Transfer progress"
          color="primary"
          sx={{ marginLeft: 0.5 }}
          onClick={() => setShowProgressDialog(true)}
          title={`传输中 (${activeCount} 个任务)`}
        >
          <CloudUploadIcon sx={{ animation: "fd-spin 1.5s linear infinite" }} />
          <style>{`@keyframes fd-spin { 100% { transform: rotate(360deg); } }`}</style>
        </IconButton>
      )}
      <IconButton
        aria-label="More"
        color="inherit"
        sx={{ marginLeft: 0.5 }}
        onClick={(e) => setAnchorEl(e.currentTarget)}
      >
        <MoreHorizIcon />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
      >
        <MenuItem>View as</MenuItem>
        <MenuItem>Sort by</MenuItem>
        <MenuItem
          onClick={() => {
            setAnchorEl(null);
            setShowProgressDialog(true);
          }}
        >
          Progress
        </MenuItem>
      </Menu>
    </Toolbar>
  );
}

export default Header;
